<neo-main-header *ngIf="configuracionPagina.menuActivo"
      [elementosMenu]="mainHeaderElementos"
      [menuInline]="configuracionPagina.menu.menuInline"
      [buttonCta]="configuracionPagina.menu.buttonCta"
      [configuracionButtonCta]="configuracionPagina.menu.configuracionButtonCta"
      [menuUser]="configuracionPagina.menu.menuUser"
      [menuIdiomas]="configuracionPagina.menu.menuIdiomas"
      [menuBurger]="configuracionPagina.menu.menuBurger"
      class="mainHeader mainHeaderNormal"
      [ngClass]="[configuracionPagina.menu.float, 'mainHeaderNormal-'+configuracionPagina.menu.normalStyle,
                  'mainHeaderSticky-'+configuracionPagina.menu.stickyStyle, 'mainHeaderBurger-'+configuracionPagina.menu.burgerStyle]"
      
>
<!-- [customProyeccion]="templateBotonReservarMenu" -->
    <!-- <neo-main-header-reservar [pathDestino]="'/reservar'"></neo-main-header-reservar> -->
</neo-main-header>
<main
    [ngClass]="{'main-container': inicioFront, 'mainContent': !inicioFront, 'paddingTop': configuracionPagina.paddingTop, 'paddingBottom': configuracionPagina.paddingBottom}">
    <router-outlet></router-outlet>
</main>


<neo-main-footer
    [elementosMenu]="mainHeaderElementos"
    [menuIdiomas]="false">
</neo-main-footer>

<neo-bloque-financiacion></neo-bloque-financiacion>

<neo-main-cta
  [iconoClase]="'icon-24 icon-ibm-email'"
  [label]="'contacto_ctc' | transloco"
  [tituloDialog]="'contacto_ctc' | transloco"
  [descripcionDialog]="'contacto_ctc_txt' | transloco"
  [tfnoCta1]="telefono1"
  [mailCta]="email1"
></neo-main-cta>

<neo-scrollUp *ngIf="configuracionPagina.scrollUp"></neo-scrollUp>

<ng-template #templateBotonReservarMenu>
    <neo-main-header-reservar [pathDestino]="'/reservar'"></neo-main-header-reservar>
</ng-template>
<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>